const LogoGrid = ({ logos }) => {
  return (
    <div className="max-w-6xl m-auto ">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-8 items-center justify-items-center">
        {logos.map((src, i) => (
          <div
            key={i}
            className="h-16 flex items-center justify-center"
          >
            <img
              src={src}
              alt={`logo-${i}`}
              className="h-full object-contain opacity-70 grayscale hover:grayscale-0 hover:opacity-100 transition duration-300"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogoGrid;